'use client';

import Icon from '@/components/ui/AppIcon';

const PartnershipBenefitsSection = () => {
  const benefits = [
    {
      icon: 'UserGroupIcon',
      title: 'Collaborative Excellence',
      description: 'Access to combined expertise across sustainability, technology, and industry-specific solutions',
    },
    {
      icon: 'CpuChipIcon',
      title: 'Technology Integration',
      description: 'Leverage cutting-edge AI, IoT, and data analytics for comprehensive ESG management',
    },
    {
      icon: 'ChartBarIcon',
      title: 'Proven Track Record',
      description: 'Partnership network with documented success across 500+ organizations',
    },
    {
      icon: 'GlobeAltIcon',
      title: 'Multi-Sector Reach',
      description: 'Comprehensive solutions spanning banking, environment, agriculture, and government sectors',
    },
    {
      icon: 'ShieldCheckIcon',
      title: 'Compliance Assurance',
      description: 'Expert guidance on BRSR, CSRD, FIBAC, and international sustainability frameworks',
    },
    {
      icon: 'SparklesIcon',
      title: 'Innovation Leadership',
      description: 'Access to pioneering sustainability technologies and methodologies',
    },
  ];

  return (
    <section className="py-20 bg-surface">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-heading font-bold text-text-primary mb-4">
            Partnership Benefits
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            Join GenCarbon's collaborative ecosystem and access comprehensive sustainability 
            solutions backed by industry-leading expertise and proven results.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits?.map((benefit, index) => (
            <div
              key={index}
              className="bg-card border border-border rounded-xl p-6 hover:shadow-natural-lg transition-all duration-300 ease-organic group"
            >
              <div className="w-14 h-14 bg-primary/10 rounded-xl flex items-center justify-center mb-4 group-hover:bg-primary group-hover:scale-110 transition-all duration-300">
                <Icon name={benefit?.icon} size={28} className="text-primary group-hover:text-white transition-colors" />
              </div>
              <h3 className="text-xl font-heading font-bold text-text-primary mb-3 group-hover:text-primary transition-colors">
                {benefit?.title}
              </h3>
              <p className="text-sm text-text-secondary leading-relaxed">
                {benefit?.description}
              </p>
            </div>
          ))}
        </div>

        {/* Success Metrics */}
        <div className="mt-16 bg-gradient-to-br from-primary/5 to-secondary/5 rounded-2xl p-8 md:p-12">
          <h3 className="text-2xl font-heading font-bold text-text-primary text-center mb-8">
            Collective Partnership Impact
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {[
              { value: '500+', label: 'Organizations Served' },
              { value: '50+', label: 'Government Projects' },
              { value: '100M+', label: 'Tonnes CO₂ Managed' },
              { value: '25+', label: 'Sectors Covered' },
            ]?.map((metric, index) => (
              <div key={index} className="text-center">
                <div className="text-3xl md:text-4xl font-heading font-bold text-primary mb-2">
                  {metric?.value}
                </div>
                <div className="text-sm text-text-secondary">{metric?.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnershipBenefitsSection;